import {
    ChangeDetectionStrategy,
    Component,
    Input,
    Output,
    EventEmitter
} from '@angular/core';
import { CommonModule, KeyValue } from '@angular/common';
import { RouterLink } from '@angular/router';
import { IconsModule } from '../../../../shared/icons/icons.module';
import { SbPendingButtonIndicatorComponent } from '../../../../shared/components/sb-pending-button-indicator/sb-pending-button-indicator.component';
import { animate, state, style, transition, trigger } from '@angular/animations';

export interface SbStep {
    title: string;
    path: string | string[] | null;
    state: SbStepState;
}

export type SbStepState =
    | 'active'
    | 'pending'
    | 'completed'
    | 'inactive'
    | 'error'
    | 'success';

export const stepBarAnimation = trigger('stepBarAnimation', [
    state(
        'completed',
        style({
            transform: 'scaleX(1)'
        })
    ),
    state(
        'active',
        style({
            transform: 'scaleX(0.25)'
        })
    ),
    state(
        'error',
        style({
            transform: 'scaleX(0.5)'
        })
    ),
    state(
        'pending',
        style({
            transform: 'scaleX(0.75)'
        })
    ),
    state(
        'inactive',
        style({
            transform: 'scaleX(0)'
        })
    ),
    transition('active=>*', [animate('400ms ease-in')]),
    transition('pending=>*', [animate('400ms ease-in')]),
    transition('*=>active', [animate('400ms 400ms ease-out')]),
    transition('inactive=>pending', [animate('10000ms 400ms ease-out')])
]);
@Component({
    selector: 'sb-step-indicator',
    standalone: true,
    imports: [CommonModule, RouterLink, IconsModule, SbPendingButtonIndicatorComponent],
    animations: [stepBarAnimation],
    templateUrl: './sb-step-indicator.component.html',
    styleUrls: ['./sb-step-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SbStepIndicatorComponent {
    get steps(): { [key: number]: SbStep } {
        return this._steps || {};
    }

    @Input() set steps(value: { [key: number]: SbStep }) {
        if (value) {
            this._steps = value;
        }
    }
    get activeStep(): number {
        return this._activeStep;
    }

    @Input() set activeStep(value: number) {
        this._activeStep = value;
    }

    @Output() onStepClick = new EventEmitter<number>();

    constructor() {}

    private _activeStep: number;
    private _steps: { [key: number]: SbStep };

    trackByMethod(index: any, step: KeyValue<string, SbStep>) {
        return step.key;
    }

    handleStepClick(stepIndex: number, step: SbStep, event: MouseEvent): void {
        stepIndex = parseInt(`${stepIndex}`);
        event.preventDefault();
        if (step.state === 'success' || step.state === 'inactive') {
            return;
        }
        this.onStepClick.emit(stepIndex);
    }
}
